import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchRunnersubsrptn(params) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let filter = (params.params && params.params.filter) || "";

  let searchParam = "";
  if (search) {
    searchParam = `&ser=${search}`;
  }

  let filterParam = "";
  if (filter) {
    filterParam = `&status=${filter}`;
  }

  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptn?status=active,pending&runnerOrgId=${id}&limit=10&page=${page}${filterParam}${searchParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_RUNNER_SUBSRIPTION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_RUNNER_SUBSRIPTION_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* requestSubsrptn(value) {
  console.log("!!!!!!!!!!!!!!!!!", value);

  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let data = {
    ...value.value,
    subscriptnPlan: value.value.subscriptnPlan.id,
    userId: value.value.userId._id,
    runner: user.id,
    currency: value.value.subscriptnPlan.crncy,
    paymentType: value.value.paymentType.id,
    status: "active",
  };
  console.log("!!!!!!!!!!!!!!!data!!", data);
  try {
    const res = yield fetch(`${appConfig.ip}/subscriptn/${value.value.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      console.log("!!!!!!!!!!!resJSON", resJSON);
      const invoicedata = {
        subscriptnId: value.value.id,
        subscriptnPlanId: resJSON.subscriptnPlan,
        subscriptnNo: resJSON.no,
        creator: resJSON.runner,
        reciever: value.value.userId._id,
        creatorOrgId: value.value.runnerOrgId,
        recieverOrgId: value.value.orgId,
        type: "subscription",
        amount: value.value.subscriptnPlan.amount,
        currency: value.value.subscriptnPlan.crncy,
        status: "paid",
        keyword: [user.orgName, value.value.userId.orgName]
      };

      try {
        const resInvoice = yield fetch(`${appConfig.ip}/invoice`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(invoicedata),
        });

        if (!resInvoice.ok) {
          throw resInvoice;
        } else {
          let resInvoiceJSON = yield resInvoice.json();

          const paymentdata = {
            subscriptnId: resInvoiceJSON.subscriptnId,
            subscriptnNo: resInvoiceJSON.subscriptnNo,
            invoiceId: resInvoiceJSON.id,
            invcNo: resInvoiceJSON.no,
            reciever: resInvoiceJSON.creator,
            userId: resInvoiceJSON.reciever,
            receiverOrgId: resInvoiceJSON.creatorOrgId,
            orgId: resInvoiceJSON.recieverOrgId,
            status: "paid",
            paymentType: value.value.paymentType.id,
            amount: resInvoiceJSON.amount,
            currency: resInvoiceJSON.currency,
            type: resInvoiceJSON.type,
            txnRefNo:value.value.txtnRefNo
          };

          try {
            const resPay = yield fetch(`${appConfig.ip}/payment`, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
              body: JSON.stringify(paymentdata),
            });

            if (!resPay.ok) {
              throw resPay;
            } else {
              let resPayJSON = yield resPay.json();

              yield put({
                type: actionTypes.CREATE_PAYMENT_SUCCESS_ACTION,
                payload: resPayJSON,
              });
            }
          } catch (err1) {
            yield put({
              type: actionTypes.CREATE_PAYMENT_FAIL_ACTION,
              error: err1,
            });
          }
          yield put({
            type: actionTypes.CREATE_INVOICE_SUCCESS_ACTION,
            payload: resInvoiceJSON,
          });
        }
      } catch (err) {
        yield put({
          type: actionTypes.CREATE_INVOICE_FAIL_ACTION,
          error: err,
        });
      }
      yield put({
        type: actionTypes.CREATE_REQUESTSUBSCRPTN_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({ type: actionTypes.FETCH_RUNNER_SUBSRIPTION_INIT_ACTION });
      yield toast.success("Subscription request succesful", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.CREATE_REQUESTSUBSCRPTN_FAIL_ACTION,
      error: err,
    });
    // yield toast.success("Subscription request failed", {
    //   autoClose: 3000,
    // });
  }
}

function* fetchCargosizeList() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/loadMetrics?isActive=true`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_CARGOSIZE_LIST_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_CARGOSIZE_LIST_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* cancelRequestSubptn(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  // const data = {
  //   subscriptnPlan: value.value.subscriptnPlan.id,
  //   runner: user.id,
  //   runnerOrgId: value.value.runnerOrgId,
  //   validityFrom: value.value.validityFrom,
  //   validityTo: value.value.validityTo,
  //   orgId: value.value.orgId,
  //   userId: value.value.userId._id,
  //   paymentType: value.value.paymentType.id,
  //   status: "cancelled",
  // };

  let data = {
    ...value.value,
    subscriptnPlan: value.value.subscriptnPlan.id,
    userId: value.value.userId._id,
    runner: user.id,
    currency: value.value.subscriptnPlan.crncy,
    paymentType: value.value.paymentType.id,
    status: "cancelled",
  };
  try {
    const res = yield fetch(`${appConfig.ip}/subscriptn/${value.value.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.CREATE_CANCELREQUEST_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({ type: actionTypes.FETCH_RUNNER_SUBSRIPTION_INIT_ACTION });
      yield toast.success("Plan cancelled successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.CREATE_CANCELREQUEST_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchHistoryRunnersubsrptn(params) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let filter = (params.params && params.params.filter) || "";

  let searchParam = "";
  if (search) {
    searchParam = `&ser=${search}`;
  }

  let filterParam = "";
  if (filter) {
    filterParam = `&status=${filter}`;
  }

  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptn?status=expired,cancelled&runnerOrgId=${id}&limit=10&page=${page}${filterParam}${searchParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_HISTORYRUNNER_SUBSRIPTION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_HISTORYRUNNER_SUBSRIPTION_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchRunnerSubscriptionLog(value) {
  const token = localStorage.getItem("token");
  console.log("----value------value------",value)
  let page = (value.params && value.params.page) || 1;
  let id = value.item;
  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptionlog?subscriptnId=${id}&limit=5&page=${page}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      console.log("@@@@@@@@@@@@@@@@@", resJSON);
      yield put({
        type: actionTypes.FETCH_RUNNERSUBSCRIPTION_LOG_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_RUNNERSUBSCRIPTION_LOG_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* RunnerSubsrptnActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_RUNNER_SUBSRIPTION_INIT_ACTION,
    fetchRunnersubsrptn
  );
  yield takeEvery(
    actionTypes.CREATE_REQUESTSUBSCRPTN_INIT_ACTION,
    requestSubsrptn
  );
  yield takeEvery(
    actionTypes.FETCH_CARGOSIZE_LIST_INIT_ACTION,
    fetchCargosizeList
  );
  yield takeEvery(
    actionTypes.CREATE_CANCELREQUEST_INIT_ACTION,
    cancelRequestSubptn
  );
  yield takeEvery(
    actionTypes.FETCH_HISTORYRUNNER_SUBSRIPTION_INIT_ACTION,
    fetchHistoryRunnersubsrptn
  );
  yield takeEvery(
    actionTypes.FETCH_RUNNERSUBSCRIPTION_LOG_ACTION,
    fetchRunnerSubscriptionLog
  );
}
